import React, { useState, useEffect } from "react";

const Counter = ({ targetNumber }) => {
  const [count, setCount] = useState(0);

  const startCounting = () => {
    const interval = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount >= targetNumber) {
          clearInterval(interval);
          return prevCount;
        }
        return prevCount + 1;
      });
    }, 10);
  };


  useEffect(() => {
    startCounting();
  }, []); 

  return (
   <>{count}</>
  );
};

export default Counter;
